import { Box, Button, Typography } from '@mui/material'
import { useNavigate, useRouteError } from 'react-router-dom'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export const ErrorPage = () => {
  const error = useRouteError() as { status?: number; statusText?: string }
  const navigate = useNavigate()
  const is404 = error?.status === 404

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: 'primary.main' }} />
      <Typography variant="h3" fontWeight={700}>
        {is404 ? '404' : 'Oops!'}
      </Typography>
      <Typography variant="h6" color="text.secondary">
        {is404 ? 'Page not found' : 'Something went wrong'}
      </Typography>
      <Button variant="contained" onClick={() => navigate('/app/dashboard')}>
        Go to Dashboard
      </Button>
    </Box>
  )
}
